module.exports = __webpack_public_path__ + "242bb864a3629d6e2f51699e47d02ea2.png";